

    <iframe 
            [src]="vidSrc" 
            width="256" height="144" 
            frameborder="0" 
            webkitallowfullscreen mozallowfullscreen allowfullscreen>
                                                </iframe>
